import DotSeparator from 'components/new-ui/base/dot-separator/DotSeparator';
import { declarationStatusColor } from 'components/ui/composed/declarations/declaration-status/DeclarationStatusTag';
import { Declaration } from 'store/declarations/declaration';
import { colors } from 'theme';
import { getDeclarationDisplayStatus } from 'views/custom-declaration/declaration-table/components/column-components/getDeclarationDisplayStatus';
import { getMessageTypeByDeclaration } from 'views/declarations/utils/declaration-utils';
import { getDeclarationUrl } from 'views/declarations/utils/getDeclarationUrl';
import { getMirroredRowDucrText } from './getMirroredRowDucrText';
import { getMirroredRowTypeLabel } from './getMirroredRowTypeLabel';
import { DucrLabel, DucrValue, RowLink, RowType, StatusDot } from './styles';

type Props = {
    declaration: Declaration;
    manifestId?: string;
    jobId?: string;
};

const MirroredDeclarationRow = ({ declaration, manifestId, jobId }: Props) => {
    if (!declaration.id) return null;

    const status = getDeclarationDisplayStatus(declaration);
    const dotColor = (status && declarationStatusColor[status]) ?? colors.lightGrey;

    const messageType = String(getMessageTypeByDeclaration(declaration) ?? '');
    const typeLabel = getMirroredRowTypeLabel(declaration, messageType);
    const ducrText = getMirroredRowDucrText(declaration, messageType);

    return (
        <RowLink
            to={getDeclarationUrl({ manifestId, jobId, declarationId: declaration.id })}
            data-testid="mirrored-declaration-row"
        >
            <RowType>
                <StatusDot $color={dotColor} />
                {typeLabel}
            </RowType>
            {ducrText && (
                <>
                    <DotSeparator />
                    <DucrLabel>
                        DUCR:
                        <DucrValue>{ducrText}</DucrValue>
                    </DucrLabel>
                </>
            )}
        </RowLink>
    );
};

export default MirroredDeclarationRow;
